import {createRouter, createWebHashHistory, createWebHistory} from 'vue-router'
import HomeView from '../views/home/home.vue'

const routes = [


  {
    path: '/temporary/home',
    name: 'temporaryHome',
    component: () => import('../views/temporary/home/home.vue'),
    children: [
      {//配送列表
        path: '/temporary/home/order_list',
        name: 'TemporaryOrderList',
        component: () => import('../views/temporary/home/order/Order.vue')
      },
      {//抢单页面
        path: '/temporary/home/grabbing',
        name: 'temporaryGrabbing',
        component: () => import('../views/temporary/home/grabbing/Grabbing.vue')
      },
      {//个人
        path: '/temporary/home/person',
        name: 'temporaryPerson',
        component: () => import('../views/temporary/home/person/Person.vue'),
      }
    ]
  },
  {//关于我们
    path: '/aboutus/home',
    name: 'AboutusHome',
    component: () => import('../views/aboutus/AboutUs.vue')
  },
  {//投诉订单列表
    path: '/complaint/order/list',
    name: 'ComplaintOrderList',
    component: () => import('../views/service/complaint/order/Order.vue')
  },
  {//临时账号登录
    path: '/temporary/user/login',
    name: 'TemporayUserLogin',
    component: () => import('../views/temporary/login/Login.vue')
  },
  {//添加临时账号
    path: '/temporary/user/create',
    name: 'TemporayUserCreate',
    component: () => import('../views/temporary/user/User.vue')
  },
  {//水卡活动领取
    path: '/user/service/water_card',
    name: 'WaterCard',
    component: () => import('../views/service/waterCard/WaterCard.vue')
  },
  {//业绩回桶详情
    path: '/user/service/achievement/roll_order',
    name: 'AchievementRollOrder',
    component: () => import('../views/service/achievement/rollOrder/RollOrder.vue')
  },
  {//业绩押金详情
    path: '/user/service/achievement/detain_order',
    name: 'AchievementDetainOrder',
    component: () => import('../views/service/achievement/detainOrder/DetainOrder.vue')
  },
  {//业绩商品详情
    path: '/user/service/achievement/goods_order',
    name: 'AchievementGoodsOrder',
    component: () => import('../views/service/achievement/goodsOrder/GoodsOrder.vue')
  },
  {//经营分析
    path: '/user/manage/analysis',
    name: 'UserManageAnalysis',
    component: () => import('../views/manage/analysis/Analysis.vue')
  },
  {//用户库存
    path: '/user/ticket/list',
    name: 'UserTicketList',
    component: () => import('../views/service/userTicket/UserTicket.vue')
  },
  {//对账单
    path: '/user/manage/reconciliation',
    name: 'ManageReconciliation',
    component: () => import('../views/manage/reconciliation/Reconciliation.vue')
  },
  {//库存管理记录
    path: '/user/manage/stock/record',
    name: 'ManageStockRecord',
    component: () => import('../views/manage/stock/record/Record.vue')
  },
  {//库存管理上报订单
    path: '/user/manage/stock/in_order',
    name: 'ManageStockInOrder',
    component: () => import('../views/manage/stock/inOrder/InOrder.vue')
  },
  {//库存管理
    path: '/user/manage/stock',
    name: 'ManageStock',
    component: () => import('../views/manage/stock/Stock.vue')
  },
  {//进货单详情
    path: '/user/manage/purchase_detail',
    name: 'PurchaseDetail',
    component: () => import('../views/manage/purchase/detail/Detail.vue')
  },
  {//回桶单详情
    path: '/user/manage/rollorder_detail',
    name: 'RollOrderDetail',
    component: () => import('../views/manage/rollorder/detail/Detail.vue')
  },
  {//回桶单记录
    path: '/user/manage/rollorder_record',
    name: 'RollOrderRecord',
    component: () => import('../views/manage/rollorder/record/Record.vue')
  },
  {//进货记录
    path: '/user/manage/purchase_record',
    name: 'PurchaseRecord',
    component: () => import('../views/manage/purchase/record/Record.vue')
  },
  {//申请进货
    path: '/user/manage/purchase',
    name: 'Purchase',
    component: () => import('../views/manage/purchase/Purchase.vue')
  },
  {//车辆库存
    path: '/user/service/car_stock',
    name: 'CarStock',
    component: () => import('../views/service/carStock/CarStock.vue')
  },
  {//我的水站
    path: '/user/manage/station',
    name: 'ManageStation',
    component: () => import('../views/manage/station/Station.vue')
  },
  {//售水机
    path: '/user/service/machine',
    name: 'Machine',
    component: () => import('../views/service/machine/Machine.vue')
  },
  {//推广商品
    path: '/user/service/spread_goods',
    name: 'SpreadGoods',
    component: () => import('../views/service/spread/Spread.vue')
  },
  {//待收款
    path: '/user/service/unpaid_order',
    name: 'UnpaidOrder',
    component: () => import('../views/service/unpaid/Unpaid.vue')
  },
  {//押/退桶记录
    path: '/user/service/detain_quit',
    name: 'DetainQuitRecord',
    component: () => import('../views/service/detainQuit/DetainQuit.vue')
  },
  {//我的配送
    path: '/user/service/dis_order',
    name: 'DisOrder',
    component: () => import('../views/service/disOrder/DisOrder.vue')
  },
  {//我的业绩
    path: '/user/service/achievement',
    name: 'Achievement',
    component: () => import('../views/service/achievement/Achievement.vue')
  },
  {//转单
    path: '/transfer',
    name: 'Transfer',
    component: () => import('../views/transfer/Transfer.vue')
  },
  {//批量转单
    path: '/transfer_all',
    name: 'TransferAll',
    component: () => import('../views/home/order/batch/Batch.vue')
  },
  {//订单详情
    path: '/home/order/detail',
    name: 'OrderDetail',
    component: () => import('../views/home/order/detail/Detail.vue')
  },
  {
    path: '/home',
    name: 'home',
    component: HomeView,
    children: [
      {//抢单页面
        path: '/home/grabbing',
        name: 'grabbing',
        component: () => import('../views/home/grabbing/Grabbing.vue')
      },
      {//配送列表
        path: '/home/order_list',
        name: 'OrderList',
        component: () => import('../views/home/order/Order.vue')
      },
      {//上报订单
        path: '/home/escalation',
        name: 'Escalation',
        component: () => import('../views/home/escalation/Escalation.vue'),
      },
      {//个人
        path: '/home/person',
        name: 'Person',
        component: () => import('../views/home/person/Person.vue'),
      }
    ]
  },

  {//登录页面
    path: '/login',
    name: 'login',
    component: () => import('../views/login/Login.vue'),
    meta: {
      keepAlive: false
    }
  },
  {//修改密码
    path: '/edit_passwd',
    name: 'EditPasswd',
    component: () => import('../views/service/passwd/Passwd.vue')
  },
  {//地图
    path: '/map',
    name: 'Map',
    component: () => import('../views/map/Map.vue')
  }
]

const router = createRouter({
  // history: createWebHistory(process.env.BASE_URL),
  history: createWebHashHistory(),
  routes
})

export default router
